import React from "react";
import {cx} from "../../../lib/ClassSet";
import StatusTag from "../../../components/StatusTag";
import {statusColor, statusLabel, shortenDate} from "../statusDisplay";
import {AdviceTag} from "../../shared/AdviceSent";

function capitalize(val) {
  if (!val) return "";
  return val.charAt(0).toUpperCase() + val.slice(1);
}

const StockTransferItem = (props) => {

  let {data} = props;
  let status = data.get("status");

  let classes = cx({
    "item": true,
    "stock-transfer-list-item": true,
    "u-selected": props.selected,
    "u-cancelled": status === "cancelled",
    "u-completed": status === "received",
  })

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-id">{data.get("id")}</td>
      <td className="field">{data.get("purchaseOrder")}</td>
      <td className="field f-warehouse">{data.get("originWarehouseId")}</td>
      <td className="field f-warehouse">{data.get("destinationWarehouseId")}</td>
      <td className="field">{capitalize(data.get("transportType"))}</td>
      <td className="field">{data.get("carrierReference")}</td>
      <td className="field f-date">{shortenDate(data.get("expectedArrivalDate"))}</td>
      <td className="field f-status">
        <StatusTag color={statusColor(status)} text={statusLabel(status)} noMargin />
        {" "}
        <AdviceTag sent={data.get("adviceSent")} sentAt={data.get("adviceSentAt")} open={status === "draft" || status === "in_transit"} />
        {data.get("archived") && " "}
        {data.get("archived") &&
          <StatusTag color={StatusTag.COLORS.GREY} text="archive" noMargin title="Recorded from an old shipment advice: received as advised, no goods receipt recorded" />}
      </td>
    </tr>
  )
}

export default StockTransferItem;
